import { mapState } from 'vuex'

export default {
    data() {
        return {}
    },

    computed: {
        ...mapState('form', {
            fields: state => state.fields,
        }),
    }
}
